import { toast } from "react-toastify";
import "./styles.css"; // your custom styles

export const showCustomToast = (message, options = {}) => {
  toast(message, {
    className: "custom-toast",
    progressClassName: "custom-progress",
    ...options,
  });
};
